import {APP_INITIALIZER, LOCALE_ID, NgModule} from '@angular/core';

import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {FooterComponent} from './components/footer/footer.component';
import {SplashScreenComponent} from "./components/splash-screen/splash-screen.component";
import {ServiceWorkerModule} from "@angular/service-worker";
import {environment} from "../environments/environment";
import {HTTP_INTERCEPTORS} from "@angular/common/http";
import {ErrorHttpInterceptor} from "./error-helpers/error-http.interceptor";
import {ErrorModule} from "./modules/error/error.module";
import {RedirectComponent} from "./components/redirect/redirect.component";
import {registerLocaleData} from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import {ClientRedirectComponent} from "./components/client-redirect/client-redirect.component";
import {SignatureRedirectComponent} from "src/app/components/signature-redirect/signature-redirect.component";
import {EndSessionComponent} from "./components/end-session/end-session.component";
import {LoaderComponent} from "./components/loader/loader.component";
import {SharedModule} from "src/app/shared.module";
import {InitServicesFactory} from "./factory/init-services.factory";
import {AppConfigService} from "./configuration/app.config.service";

registerLocaleData(localeFr, 'fr');

@NgModule({
    declarations: [
        AppComponent,
        FooterComponent,
        SplashScreenComponent,
        RedirectComponent,
        ClientRedirectComponent,
        SignatureRedirectComponent,
        EndSessionComponent,
        LoaderComponent
    ],
    imports: [
        SharedModule,
        AppRoutingModule,
        ErrorModule,
        ServiceWorkerModule.register('ngsw-worker.js', {enabled: environment.production}),
    ],
    providers: [
        {provide: APP_INITIALIZER, useFactory: InitServicesFactory, deps: [AppConfigService], multi: true },
        {provide: HTTP_INTERCEPTORS, useClass: ErrorHttpInterceptor, multi: true},
        {provide: LOCALE_ID, useValue: "fr-FR"}
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
